// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1g84B","notes":"Notes_notes__2elIZ"};